import { createSlice } from "@reduxjs/toolkit";
import { getAgentSubscriptions, getClubSubscriptions, getMemberSubscriptions, getScoutSubscriptions } from "./_subscriptionAction";

const initialState: any = {
  data: [],
  subscriptions:[],
  agentSubscriptions: [],
  clubSubscriptions: [],
  scoutSubscriptions: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const subscriptionList = createSlice({
  name: "subscriptionList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getMemberSubscriptions.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getMemberSubscriptions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.subscriptions = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getMemberSubscriptions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
      // Agent Subscriptions
      .addCase(getAgentSubscriptions.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getAgentSubscriptions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.agentSubscriptions = payload.data || [];
        state.responseMessage = payload.responseMessage;
        state.responseCode = payload.responseCode;
        state.totalRecord = payload.totalRecord || 0;
      })
      .addCase(getAgentSubscriptions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })

      // Club Subscriptions
      .addCase(getClubSubscriptions.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getClubSubscriptions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.clubSubscriptions = payload.data || [];
        state.responseMessage = payload.responseMessage;
        state.responseCode = payload.responseCode;
        state.totalRecord = payload.totalRecord || 0;
      })
      .addCase(getClubSubscriptions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })

      // Scout Subscriptions
      .addCase(getScoutSubscriptions.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getScoutSubscriptions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.scoutSubscriptions = payload.data || [];
        state.responseMessage = payload.responseMessage;
        state.responseCode = payload.responseCode;
        state.totalRecord = payload.totalRecord || 0;
      })
      .addCase(getScoutSubscriptions.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});
